module.exports = __webpack_public_path__ + "static/img/wl.1a79f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit/wl.png
// module id = RSqW
// module chunks = 1